<template>
  <section>
    <div class="container">
      <div class="jumbo jumbo--md">
        <div class="row">
          <div class="col-m-8">
            <article class="article mb-24">
              <h3>Jobboo Worker - о приложении</h3>
              <p>Jobboo - сервис для поиска исполнителей на микробытовые задачи: мелкий бытовой ремонт, уборка, ремонт бытовой техники и электроники.</p>
              <p>Jobboo Worker - приложение, которое позволяет работникам найти релевантные заявки от клиентов поблизости и оперативно на них отреагировать.</p>
            </article>
          </div>
        </div>
        <div class="row">
          <div class="col-m-3">
            <div class="feature mb-24">
              <div class="feature__label">География проекта</div>
              <div class="feature__content">Барселона, Испания</div>
            </div>
          </div>
          <div class="col-m-3">
            <div class="feature mb-24">
              <div class="feature__label">Срок реализации</div>
              <div class="feature__content">3 месяца</div>
            </div>
          </div>
          <div class="col-m-8">
            <div class="feature mb-24">
              <div class="feature__label">Тех. стек</div>
              <div class="feature__content">Webview на базе VueJS (SPA), Swift, Flutter, Restful API на Laravel, Redis, Websocket, Google Maps API, Firebase, AWS, Git.</div>
            </div>
          </div>
        </div>
        <div>
          <a href="#" @click.prevent="showModal('5e60b459ad16fa004472f7c5')" class="button">Расчет Стоимости</a>
        </div>
      </div>
    </div>
    <Slider :images="images"></Slider>
    <div class="mt-60">
      <h3 class="section__title">Другие проекты</h3>
      <Portfolio />
    </div>
    <div class="text-center">
      <a href="#" @click.prevent="showModal('5e60b459ad16fa004472f7c5')" class="button">Расчет Стоимости</a>
    </div>
    <Clients />
    <VueFooter />
  </section>
</template>
<script>
const name = 'jobbooworker'

import Portfolio from '@/components/Portfolio.vue'
import Clients from '@/components/Clients.vue'
import Slider from '@/components/Slider.vue';
import VueFooter from '@/components/VueFooter.vue';

function data() {
  return {
    images: [
      require('@/assets/img/jobbooworker/1.jpg'),
      require('@/assets/img/jobbooworker/2.jpg'),
      require('@/assets/img/jobbooworker/3.jpg'),
      require('@/assets/img/jobbooworker/4.jpg'),
      require('@/assets/img/jobbooworker/5.jpg'),
      require('@/assets/img/jobbooworker/6.jpg'),
      require('@/assets/img/jobbooworker/7.jpg'),
      require('@/assets/img/jobbooworker/8.jpg'),
      require('@/assets/img/jobbooworker/9.jpg'),
      require('@/assets/img/jobbooworker/10.jpg'),
      require('@/assets/img/jobbooworker/11.jpg'),
      require('@/assets/img/jobbooworker/12.jpg'),
      require('@/assets/img/jobbooworker/13.jpg'),
      require('@/assets/img/jobbooworker/14.jpg'),
      require('@/assets/img/jobbooworker/15.jpg'),
      require('@/assets/img/jobbooworker/16.jpg'),
      require('@/assets/img/jobbooworker/17.jpg'),
      require('@/assets/img/jobbooworker/18.jpg'),
      require('@/assets/img/jobbooworker/19.jpg'),
      require('@/assets/img/jobbooworker/20.jpg'),
      require('@/assets/img/jobbooworker/21.jpg'),
      require('@/assets/img/jobbooworker/22.jpg'),
      require('@/assets/img/jobbooworker/23.jpg'),
      require('@/assets/img/jobbooworker/24.jpg'),
      require('@/assets/img/jobbooworker/25.jpg'),
      require('@/assets/img/jobbooworker/26.jpg'),
      require('@/assets/img/jobbooworker/27.jpg'),
      require('@/assets/img/jobbooworker/28.jpg'),
      require('@/assets/img/jobbooworker/29.jpg'),
      require('@/assets/img/jobbooworker/30.jpg'),
      require('@/assets/img/jobbooworker/31.jpg'),
      require('@/assets/img/jobbooworker/32.jpg'),
      require('@/assets/img/jobbooworker/33.jpg'),
      require('@/assets/img/jobbooworker/34.jpg'),
      require('@/assets/img/jobbooworker/35.jpg'),
      require('@/assets/img/jobbooworker/36.jpg')
    ]
  }
}

export default {
  name,
  data,
  components: {
    Slider,
    Portfolio,
    Clients,
    VueFooter
  }
}

</script>
